/* eslint-disable prefer-template */
/* eslint-disable no-param-reassign */
/* eslint-disable semi */
/* eslint-disable no-dupe-keys */
import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';
import api from '../../../service/api';
import { PAGEINFO, RANGEINIT, CONFIG_BTN } from './operatorListReducer';

export const PAGEINFO_ASYNC = PAGEINFO + '_ASYNC';
export const RANGEINIT_ASYNC = RANGEINIT + '_ASYNC';

// worker
export function* pageInfoAsync(action) {
  const res = yield api.pageInfo({
    currentPage: 0,
    pageSize: action.pageSize,
    userId: action.wd,
    currentPage: action.currentPage,
  });
  if (res.operatorInfoPageList) {
    res.operatorInfoPageList.content.forEach((v, i) => {
      v.key = i;
    })
  }
  yield put({
    type: PAGEINFO,
    operatorInfoPageList: res.operatorInfoPageList,
  });
}

export function* rangeInitAsync(action) {
  const res = yield api.rangeInit(action.option);
  console.log(res);

  yield put({
    type: RANGEINIT,
    roleAndProduct: {
      userRoleList: res.userRoleList,
      productsList: res.productsList,
      isManageAll: res.isManageAll,
    },
  });

  yield put({
    type: CONFIG_BTN,
    isShow: true,
  });
}

// watcher
export default function* watchRootSaga() {
  yield takeLatest(PAGEINFO_ASYNC, pageInfoAsync);
  yield takeLatest(RANGEINIT_ASYNC, rangeInitAsync);
}



// WEBPACK FOOTER //
// ./src/views/Business/OperatorList/saga.js